export const quantidadeDeProdutosDatabelaDefault = 150;
